import {
  AddressSearch,
  EmptyInput,
  InputGroup, InputGroupBreak, InputRow, ModelInput,
} from '@equifinance/shared';
import { StaticDataItem } from '../../../../../api/useAccountApi';
import {
  useAccountContext,
} from '../../../../../contexts';
import { PaddedSection } from '../../../components/Section';
import { EmployedOrCIS, EmploymentHistory } from '../../../../../contexts/account/IncomeAndEmployment';
import { ineSubSectionHeaderCss } from './IncomeAndEmploymentSection';

const employmentStatusIsEmployed: EmploymentHistory['employmentType'][] = [
  'Employed',
  'ConstructionIndustryScheme',
];

export default function EmployerDetailsSection({
  employmentHistory,
  applicantIndex,
  ukCountries,
  employmentHistoryIndex,
}: {
  employmentHistory: EmploymentHistory,
  applicantIndex: number,
  ukCountries: StaticDataItem[],
  employmentHistoryIndex: number,
}) {
  const { account } = useAccountContext();
  const { errors, warnings } = account;
  const {
    id,
    employer,
    currentlyWorkingInThisRole,
    employmentType,
  } = employmentHistory as EmployedOrCIS;

  const field = `applicants[${applicantIndex}].incomeAndEmployment.employmentHistory[${employmentHistoryIndex}]`;

  if (
    !currentlyWorkingInThisRole
    || !employmentStatusIsEmployed.includes(employmentType)
  ) {
    return null;
  }

  return (
    <PaddedSection
      id={id}
      title="Employer details"
      level={2}
      errors={errors}
      warnings={warnings}
      headerCss={ineSubSectionHeaderCss}
      titleIcon={<></>}
    >
      <InputGroup>
        <InputRow>
          <ModelInput
            label="Employer name"
            field={`${field}.employer.employerName`}
            required
          />
          <EmptyInput />
        </InputRow>

      </InputGroup>

      <InputGroupBreak />

      <AddressSearch
        addressId={employer?.address?.id}
        field={`${field}.employer.address`}
        errors={errors}
        searchPlaceholder="Enter postcode or first line of employers address"
        countries={ukCountries?.reduce((prev, current) => ({
          ...prev,
          [current?.key]: current?.label,
        }), {} as Record<string, string>)}
        subBuildingLabel="Sub-building number"
        buildingNameLabel="Building name"
        buildingNumberLabel="Building number"
      />
    </PaddedSection>
  );
}
